import { ax } from '../../../client'
import serviceURLS from './serviceURLS'

export const getFees = () => {
  return ax.get(serviceURLS.FEES)
}

export const updateFees = (payload, product) => {
  return ax.put(serviceURLS.FEES, payload, {
    params: { product: product }
  })
}

export const getInvestors = () => {
  return ax.get(serviceURLS.FIND_INVESTORS)
}

export const getAccounts = (params) => {
  return ax.get(serviceURLS.ACCOUNTS, { params })
}

export const getSupportedCountries = () => {
  return ax.get(serviceURLS.SUPPORTED_COUNTRIES)
}

export default {
  getFees,
  getInvestors,
  updateFees,
  getSupportedCountries
}
